import directives from './module';
import {Strings} from 'Strings';
import {Utils} from 'underscore-extensions';

export class SearchCtrl {
    username?: string;
    keyword: string      = this.$stateParams.q;
    solr?: boolean       = !_.isUndefined(this.$stateParams.solr);
    myProjects?: boolean = !_.isUndefined(this.$stateParams.myProjects);
    onStart: Function | undefined;

    constructor(private $state: ng.ui.IStateService,
                private $q: ng.IQService,
                private $stateParams: {solr?: string, myProjects?: string, q?: string}) {}

    startSearch(notify = true): ng.IPromise<any> {
        if (Strings.isBlank(this.keyword)) return this.$q.resolve();
        if (_.isFunction(this.onStart)) this.onStart();

        return this.$state.transitionTo('studio-search', {
            q: this.keyword,
            username: this.username,
            myProjects: this.myProjects || undefined,
            solr: this.solr || undefined
        }, {reload: true, notify}).then(() =>
            setTimeout(() => Utils.safe(() => document.querySelector('.project-search').focus()), 100)
        );
    }
}

directives.component('search', {
    controller: SearchCtrl,
    controllerAs: 'Search',
    bindings: {
        username: '@',
        onStart: '&?'
    },
    templateUrl: require('search.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/searchDirective.ts